/**
 * Generates a `mailto:` URL with a pre-filled subject + body for replying
 * to a customer about a specific order or quote. Keeps your tone consistent
 * across replies and saves ~30 seconds per email.
 */
function _enc(s) {
  return encodeURIComponent(s || "");
}

export function replyInboxOrder(order) {
  const customerName = (order?.customer?.name || "").split(" ")[0] || "there";
  const customerEmail = order?.customer?.email || "";
  const orderNumber = order?.order_number || "";
  const total = typeof order?.total === "number" ? order.total.toFixed(2) : "";
  const subject = `Re: Toronto Custom — Order ${orderNumber}`;
  const body =
`Hi ${customerName},

Thanks for your order ${orderNumber}${total ? ` ($${total} CAD)` : ""}.

[ your message here ]

Anything else I can help with?

Cheers,
Toronto Custom T-Shirts
2404 Haines Rd Suite 209, Mississauga, ON
(289) 205-3623 · torontocustomt@gmail.com`;
  return `mailto:${_enc(customerEmail)}?subject=${_enc(subject)}&body=${_enc(body)}`;
}

export function replyInboxQuote(quote) {
  const name = (quote?.name || "").split(" ")[0] || "there";
  const email = quote?.email || "";
  const reqNumber = quote?.request_number || "";
  const product = quote?.product_type || "custom apparel";
  const qty = quote?.quantity || "";
  const subject = `Re: Toronto Custom Bulk Quote ${reqNumber}`;
  const body =
`Hi ${name},

Thanks for reaching out about ${qty ? `${qty} ` : ""}${product}. I've reviewed your request${reqNumber ? ` (${reqNumber})` : ""} — here's what I can offer:

[ your pricing / questions / next-steps here ]

Happy to jump on a quick call if it's easier. Let me know what works.

Cheers,
Toronto Custom T-Shirts
2404 Haines Rd Suite 209, Mississauga, ON
(289) 205-3623 · torontocustomt@gmail.com`;
  return `mailto:${_enc(email)}?subject=${_enc(subject)}&body=${_enc(body)}`;
}
